export const ASSISTANT_MIN_W = 360;
export const ASSISTANT_MIN_H = 400;
export const ASSISTANT_PREFERRED_W = 420;
export const ASSISTANT_PREFERRED_H = 560;
export const ASSISTANT_GAP = 16;
export const ASSISTANT_BOTTOM = 16;

export type AssistantFrameInput = {
  innerWidth: number;
  innerHeight: number;
};

export function assistantMaxSize(innerWidth: number, innerHeight: number): { maxW: number; maxH: number } {
  return {
    maxW: Math.max(ASSISTANT_MIN_W, innerWidth - ASSISTANT_GAP * 2),
    maxH: Math.max(ASSISTANT_MIN_H, innerHeight - ASSISTANT_BOTTOM - ASSISTANT_GAP),
  };
}

export function clampAssistantSize(
  w: number,
  h: number,
  innerWidth: number,
  innerHeight: number,
): { w: number; h: number } {
  const { maxW, maxH } = assistantMaxSize(innerWidth, innerHeight);
  return {
    w: Math.min(Math.max(w, ASSISTANT_MIN_W), maxW),
    h: Math.min(Math.max(h, ASSISTANT_MIN_H), maxH),
  };
}

export function clampAssistantPosition(
  right: number,
  bottom: number,
  w: number,
  h: number,
  innerWidth: number,
  innerHeight: number,
): { right: number; bottom: number } {
  const maxRight = Math.max(ASSISTANT_GAP, innerWidth - w - ASSISTANT_GAP);
  const maxBottom = Math.max(
    ASSISTANT_BOTTOM,
    innerHeight - h - ASSISTANT_GAP,
  );
  return {
    right: Math.min(Math.max(right, ASSISTANT_GAP), maxRight),
    bottom: Math.min(Math.max(bottom, ASSISTANT_BOTTOM), maxBottom),
  };
}

/** Bottom-right corner of the browser window. */
export function assistantDefaultFrame(input: AssistantFrameInput): {
  w: number;
  h: number;
  right: number;
  bottom: number;
} {
  const { maxW, maxH } = assistantMaxSize(input.innerWidth, input.innerHeight);
  const w = Math.min(ASSISTANT_PREFERRED_W, maxW);
  const targetH = Math.round(input.innerHeight * 0.62);
  const h = Math.min(ASSISTANT_PREFERRED_H, Math.max(ASSISTANT_MIN_H, targetH), maxH);
  return { w, h, right: ASSISTANT_GAP, bottom: ASSISTANT_BOTTOM };
}
